import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import storage from 'util/storage';
import { openGlobalModal } from 'actions/modal';
import { toggleLoading } from 'actions/global';

import { wrapFetch, wrapFetchAuth } from './endpoint';

export const getOldData = createAction('GET_OLD_DATA', (account, password) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch('api/web/user/oldData', {
		method: 'POST',
		body: JSON.stringify({ account, password }),
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		dispatch(push('/sync'));
		const token = {
			account,
			password,
		};
		storage.setItem('old', JSON.stringify(token));
		return {
			oldData: data,
			loginErr: false,
		};
	} else if (status === 404) {
		return {
			loginErr: true,
		};
	}
	return {};
});

export const onEnterGetOldData = createAction('ONENTER_GET_OLD_DATA', () => async dispatch => {
	const old = JSON.parse(storage.getItem('old'));

	if (old) {
		dispatch(toggleLoading(true));
		const { status, data } = await wrapFetch('api/web/user/oldData', {
			method: 'POST',
			body: JSON.stringify({ account: old.account, password: old.password }),
		});
		dispatch(toggleLoading(false));

		if (status === 200) {
			return {
				oldData: data,
			};
		}
	}
	return {};
});

export const oldDataSync = createAction('OLD_DATA_SYNC', () => async dispatch => {
	const old = JSON.parse(storage.getItem('old'));
	dispatch(toggleLoading(true));
	const { status, data, message } = await wrapFetchAuth('api/web/user/sync', {
		method: 'POST',
		body: JSON.stringify({ account: old.account, password: old.password }),
	});
	dispatch(toggleLoading(false));

	if (status === 200 || status === 201) {
		dispatch(push('/product'));
	} else if (status === 400 && message === 'fail series numbers') {
		dispatch(openGlobalModal('oldSyncFailSeries'));
		return {
			oldDataFail: data,
		};
	} else if (status === 400 && message !== 'fail series numbers') {
		dispatch(openGlobalModal('oldSyncFail'));
	} else if (status === 404) {
		dispatch(openGlobalModal('oldSyncFail'));
	}
	return {};
});

export const oldLogout = createAction('OLD_LOGOUT', () => async () => {
	storage.removeItem('old');
});



// WEBPACK FOOTER //
// ./src/actions/oldsystem.js